import type { Papel } from '@triade/contracts';

/** Papeis que corrigem ou excluem vigencias de parametros (a API tambem exige; a tela so esconde). */
export const PAPEIS_CORRIGEM_VIGENCIA: readonly Papel[] = ['ADMIN_EMPRESA', 'ADMIN_TENANT', 'CONSULTOR', 'SUPERADMIN'];

/** Por papel (nao por permissao): true se algum dos papeis do usuario na empresa pode corrigir vigencia. */
export function podeCorrigirVigencia(papeis: readonly Papel[] | null | undefined): boolean {
  return (papeis ?? []).some((p) => PAPEIS_CORRIGEM_VIGENCIA.includes(p));
}
